import React, { Suspense } from 'react';
import { Spinner } from "react-bootstrap";

import Belt from '../components/Belt';
import BeltLogged from '../components/BeltLogged';

import Footer from '../components/Footer';
import MapSearch from '../components/MapSearch';
import PageCounterNew from '../components/PageCounterNew';

import FechPostSparingBySearch from "../fechData/FechPostSparingBySearch";

//UTILS
import DateTimeNow from "../utils/DateTimeNow";

import ParseLinkToArray from "../utils/ParseLinkToArray";
import queryString from 'query-string';

const AdverbSparingParnerShort = React.lazy(() => import('../components/AdverbSparingParnerShort'));

class SparingpartnersPage extends React.Component {

  searchSparingItem = {
    page: ''
  };
  urlDeafulValues = [];
  urlValue = "";

  state = {
    title: "Sparingpartnerzy - RezerwujKort.pl",
    logInfo: "LogDebug __" + DateTimeNow() + "__ SparingpartnersPage ",
    rowsCount: "6",
    restSparingAdverbsData: {
      successful: false,
      status: "",
      message: "",
      data: [],
    }
  };

  async componentDidMount() {

    document.title = this.state.title

    const { location: { search } } = this.props;
    this.urlValue = queryString.parse(search);

    this.searchSparingItem = await ParseLinkToArray(this.urlValue, this.searchSparingItem, this.urlDeafulValues);
    var result = await FechPostSparingBySearch(this.searchSparingItem);
    this.setState({
      restSparingAdverbsData: result,
    });
  }

  render() {

    var adverbs = "";
    if (this.state.restSparingAdverbsData.successful &&
      typeof this.state.restSparingAdverbsData.data.content.map === 'function') {
      adverbs = this.state.restSparingAdverbsData.data.content.map(adverbOne =>
        <div>
          <Suspense fallback={<div>
            <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
          </div>}>
            <AdverbSparingParnerShort adverb={adverbOne} />
          </Suspense>
        </div>);
    }

    const urlValues = new Map();
    urlValues.set('page', "replace");

    var pageCounter = "";
    if (this.state.restSparingAdverbsData.successful) {
      pageCounter = <PageCounterNew
        elementCount={this.state.restSparingAdverbsData.data.totalElements}
        urlValues={urlValues}
        urlDeafulValues={this.urlDeafulValues}
        elementOnPage={this.state.rowsCount}
        currentPage={parseInt(this.searchSparingItem.page) + 1}
        searchName={"sparing_search"}
        linkTo={"sparingpartnerzy"}
      />
    }

    return (

      <div>

        <Belt />

        <BeltLogged />

        <div id="content">
          <div className="container">
            <div className="main-subpage">
              <div className="head">

                <img src={`/images/login.png`} />
                <p>Sparingpartnerzy</p>
              </div>

              <MapSearch linkTo={"sparingpartnerzy_search"} />

              <div style={{ clear: 'both' }}>
                <div className="main-subpage-subtitle">Sparingpartnerzy</div>

                {adverbs}

              </div>

              <div >
                {pageCounter}
              </div>

            </div>

          </div>
        </div>

        <Footer />

      </div>
    );
  }
}

export default SparingpartnersPage;
